import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as campaignActions from '../../../redux/actions/CampaignsActions';
import * as suggestionActions from '../../../redux/actions/SuggestionsActions';
import { createCampaignList, getAllCampaignLists } from '../../../redux/actions/CampaignListsActions';
import { getExternalCampaignListRecipients } from '../../../redux/actions/ExternalCampaignListsActions';
import { updateApplicationsStatus } from '../../../redux/actions/ApplicationsActions';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CampaignStatusTag from '../../commonComponents/shared/CampaignStatusTag';
import CampaignDetailsTable from './CampaignDetailsTable';
import EditCampaignModal from './EditCampaignModal';
import { toastr } from 'react-redux-toastr';
import { formatDate, formatCurrency, locationIsIsraeli } from '../../../lib/utils';
import { PermissionTypes, CampaignStatuses } from '../../../lib/systemVariables';
import queryString from 'query-string';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';

class CampaignDetailsPage extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      campaignId: this.props.match.params.id,
      showModals: {
        editCampaignModal: false,
        deleteCampaignModal: false,
      },
      deleting: {
        loading:false,
        success:false,
        message: 'We were unable to delete the campaign. It may have paid or accepted applications. Please try again.'
      }
    }
  }

  componentWillMount() {
    if (this.state.campaignId) {
      this.getDetails();
    }
  }
  
  componentWillUnmount() {
    this.props.actions.clearCampaignDetails();
  }

  async deleteCampaign() {
    await this.props.actions.deleteCampaign(this.state.campaignId);

    if (this.props.campaignDelete.success) {
      this.pushRoute(`/campaigns/`);
    }
  }

  async getDetails() {
    await this.props.actions.getCampaignDetails(this.state.campaignId);
    if (!this.props.details.success) {
      toastr.error('Something went wrong', `We were unable to retrieve campaign list details.  Please try again.`);
    }
  }

  render() {
    let campaign = {
      ...this.props.details.data
    };
    campaign.isIsraeli = locationIsIsraeli(this.props.locationGroups, campaign.locationId);

    const locationGroup = campaign.locationId ?
      this.props.locationGroups[this.props.locationGroups.map(loc => loc.groupId.toString()).indexOf(campaign.locationId.toString())] : null;

    return (
      <div className="page campaign">
        <div className="subheader campaign-header campaign-details-header">
          {this.props.details.loading ? <LoadingSpinner height="30" /> : <div className="container flex-justify">
            <div>
              <h2 className="page-header">
                {campaign.name} <CampaignStatusTag status={campaign.status} />
              </h2>
              <div className="flex campaign-header-icons">
                <div>
                  <p className="small-text"><i className="icon-calendar icon-left accent-text2"></i>{formatDate(campaign.dateCreated)} - {formatDate(campaign.endDate)}</p>
                  <p className="small-text">
                    {campaign.isIsraeli ? <i className="material-icons shekel-icon icon icon-left accent-text2">₪</i> : <i className="icon ion-social-usd icon-left accent-text2"></i>}
                    {formatCurrency(campaign.isIsraeli ? campaign.maxAmountShekel : campaign.maxAmountDollar, campaign.isIsraeli)} limit
                  </p>
                </div>
                <div>
                  {(campaign.fundNames && campaign.fundNames.length > 0) && <p className="small-text"><i className="icon-home icon-left accent-text2"></i>{campaign.fundNames.join(', ')}</p>}
                  <p className="small-text"><i className="icon-user icon-left accent-text2"></i>Approver: {campaign.approverName}</p>
                </div>
                <div>
                  <p className="small-text"><i className="icon-credit-card icon-left accent-text2"></i>Campaign Total (to date): {campaign.totalFunds}</p>
                  {locationGroup && locationGroup.members.length > 0 &&
                    <p className="small-text"><i className="icon-location-pin icon-left accent-text2"></i>
                      {locationGroup.members.map(loc => loc.city).join(', ') || locationGroup.members[0].country} </p>}
                </div>
              </div>
            </div>
            <div className="campaign-header-right">
              <div className="campaign-header-right-left">
                { (
                  campaign.canDelete
                  //flag sent from API - determines if campaign can be deleted based if user has appropriate institution/individuals permission and if campaign has approved/paid applications
                  && (!this.props.campaignListsTable.loading)  
                  && (!this.props.campaignIndividualsTable.loading)
                )
                  ? <button 
                    className="btn btn-danger"
                    onClick={this.toggleModal.bind(this, "deleteCampaignModal")}
                  >Delete</button> 
                  : ''}
                {this.props.userPermissions.manage
                  && <button className="btn btn-primary" onClick={this.toggleModal.bind(this, "editCampaignModal")}>{campaign.status === CampaignStatuses.Open ? "Edit" : "Extend"}</button>}
              </div>
              <div className="campaign-header-right-right">
                <p className="small-text accent-text"><i className="icon-clock icon-left"></i>Updated by {campaign.lastUpdatedBy}</p>
              </div>
            </div>
          </div>}
        </div>

        {campaign.campaignId && <CampaignDetailsTable
          isAdmin={this.props.userPermissions.admin}
          view={queryString.parse(this.props.history.location.search).view || (this.props.userPermissions.individuals ? 'lists' : 'individuals')}
          toggleView={view => this.props.history.replace({ search: view !== 'lists' ? `?view=${view}` : '' })}
          canUpdate={this.props.userPermissions.manage && campaign.status === CampaignStatuses.Open}
          canApproveApplications={this.props.userPermissions.approveApplications && campaign.status === CampaignStatuses.Open}
          canUpdateRecipients={this.props.userPermissions.manageApplications && campaign.status === CampaignStatuses.Open}
          campaignId={this.state.campaignId}
          campaign={campaign}
          actions={this.props.actions}
          listsTable={this.props.campaignListsTable}
          individualsTable={this.props.campaignIndividualsTable}
          lists={this.props.lists}
          receivingParticipants={this.props.receivingParticipantsTable}
          individuals={this.props.individuals}
          approvingIndividuals={this.props.approvingCampaignIndividuals}
          campaignLists={this.props.campaignLists}
          campaignListStatuses={this.props.campaignListStatuses || []}
          creatingCampaignList={this.props.campaignListCreate}
          externalCampaignListRecipients={this.props.externalCampaignListRecipients}
          recipientSuggestions={this.props.recipientSuggestions}
          systemSettings={this.props.systemSettings}
          locationGroups={this.props.locationGroups}
          funds={this.props.funds}
          organizations={this.props.organizations}
          references={this.props.references}
          userPermissions={this.props.userPermissions} />}

        <EditCampaignModal
          show={this.state.showModals.editCampaignModal}
          close={this.toggleModal.bind(this, "editCampaignModal")}
          {...this.props.updateCampaignDetails}
          campaign={campaign}
          approvers={this.props.approvers || []}
          updateCampaign={this.props.actions.updateCampaign} />

          
          <ConfirmationModal
            show={this.state.showModals.deleteCampaignModal}
            message={this.state.campaignId ? `Are you sure you want to permanently delete ${campaign.name} campaign?` : ''}
            close={() => {
                this.toggleModal("deleteCampaignModal");
            }}
            confirm={() => this.deleteCampaign(this.state.campaignId)}
            loading={this.state.deleting.loading}
            success={this.state.deleting.success}
            errorMessage={ this.state.deleting.message } />
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    ...state.campaignDetails,
    campaignListsTable: state.campaignDetailsListsTable,
    campaignIndividualsTable: state.campaignDetailsIndividualsTable,
    receivingParticipantsTable: state.receivingParticipantsTable,
    approvingCampaignIndividuals: state.applications.updating,
    campaignLists: state.campaignLists.allCampaignLists,
    campaignListCreate: state.campaignLists.newCampaignList,
    campaignListStatuses: state.settings.systemSettings.data.otherSettings.campaignListStatuses,
    externalCampaignListRecipients: state.externalCampaignList.listRecipients,
    recipientSuggestions: state.suggestions.recipientSuggestions,
    systemSettings: state.settings.systemSettings.data,
    locationGroups: state.settings.systemSettings.data.campaignSettings.locationGroups.filter(lg =>
      state.userProfile.profile.data.departments.indexOf(lg.department) >= 0),
    approvers: state.users.approvers.data,
    references: state.references.references,
    organizations: state.recipientAccounts.organizations.data,
    funds: state.funds.fundsByDept,
    userPermissions: {
      admin: state.userProfile.profile.data.roleId === 1,
      manage: state.userProfile.permissions.data.indexOf(PermissionTypes.CampaignAndListsManage) >= 0,
      approveApplications: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveFull) >= 0
        || state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsApproveLimited) >= 0,
      manageApplications: state.userProfile.permissions.data.indexOf(PermissionTypes.ApplicationsManage) >= 0,
      individuals: state.userProfile.permissions.data.indexOf(PermissionTypes.IndividualsManage) >= 0,
      institutions: state.userProfile.permissions.data.indexOf(PermissionTypes.InstitutionsManage) >= 0
    },
    campaignDelete: { ...state.campaigns.campaignDelete },
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...campaignActions,
      createCampaignList,
      getAllCampaignLists,
      getExternalCampaignListRecipients,
      ...suggestionActions,
      updateApplicationsStatus,
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetailsPage);


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsPage.jsx